import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalHeader } from 'react-bootstrap'
import Profile from '../../assets/img/profile.png'
import { dateFunction } from '../../helper/utils'
import Logo from '../../assets/img/CloseLogo.png'
import moment from 'moment'

const getModifiedData = (data) => {
    return Object.keys(data).filter(ele => !['_id', '__v', 'isDeleted', 'application', 'isFavorite'].includes(ele)).map(key => {
        if (['bloggerAccount'].includes(key)) {
            return ({ key: key, value: data[key].email })
        }
        if (['createdBy', 'updatedBy'].includes(key)) {
            return ({ key: key, value: data[key].name })
        }
        if (key == "extraFields") {
            const temp = Object.keys(data[key]).map((ele) => {
                return `${ele} : ${data[key][ele]} \n`
            }).join("");
            return ({ key: key, value: temp })
        }
        if (['createdAt', 'updatedAt'].includes(key)) {
            return ({ key: key, value: moment(data[key]).local().format('DD-MM-YYYY hh:mm:ss a') })
        }
        return ({ key: key, value: data[key] })
    })
}

const ViewJsonUrlApp = ({ show, onHide, data }) => {
    console.log('data', data)
    return (
        <Modal
            show={show}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='view_activity_modal'
            onHide={onHide}
        >
            <ModalHeader closeButton>
                <img src={data?.logo ? data.logo : Logo} alt="" width="25px" />
                <div className='header_detail'>
                    <h4 className='title'>{data?.name}</h4>
                    {/* <div style={{ display: 'flex', gap: '10px' }}>
                        <h4 className='type'>{data?.type}</h4>
                        <h4 className='type'>{data?.createdBy}</h4>
                        <h4 className='type'>{data?.createdAt}</h4>
                    </div> */}
                </div>
            </ModalHeader>
            <Modal.Body>
                <table className='view_activity_modal_table'>
                    <thead>
                        <tr>
                            <th>Field Name</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && getModifiedData(data).map(item => {
                            return (
                                <tr key={item}>
                                    <td className='td_fildName'>{item.key}</td>
                                    <td className='td_design' style={{ width: "75%" }}>{item.value}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <div className='d-flex justify-content-end mt-3 gap-4'>
                    <Button className='header_cancel_button' onClick={onHide}>Close</Button>
                </div>
            </Modal.Body>
        </Modal >
    )
}

export default ViewJsonUrlApp